module.exports = __webpack_public_path__ + "static/img/cont51 (4).48f2883.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont51 (4).jpg
// module id = +uyx
// module chunks = 0